import React, { Component } from "react";
import EventEmitter, { Events } from "./../../services/eventemitter";
import { LocalStorageService } from "./../../services/localStorageService";
import { LoginResponse, Websites } from "./../../models";
import { wglcsApiService } from "./../../services/WglcsApiService";

interface WebsitesDataState {
    websites: Websites[];
    loader: boolean;
}

class WebsitesData extends Component<{}, WebsitesDataState> {
    constructor(props: {}) {
        super(props);
        this.state = {
            websites: [],
            loader: true
        };

        EventEmitter.on(Events.loadWebsites, this.loadWebsites);
        EventEmitter.on(Events.requestForWebsiteData, this.requestForWebsiteData);
    }

    requestForWebsiteData = (): void => {
        if (this.state.websites?.length > 0) {
            EventEmitter.emit(Events.passDataToChilds, {
                loader: this.state.loader,
                data: this.state.websites
            });
        }
        else {
            EventEmitter.emit(Events.passDataToChilds, {
                loader: true,
                data: []
            });
            this.loadWebsites()
        }
    };

    loadWebsites = async () => {
        const UserData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
        const response = await wglcsApiService.getwebsitesbyempCompany(
            UserData?.userLoginData?.empCompId
        );

        if (response?.data?.status) {
            this.setState({
                websites: response?.data?.data,
                loader: false
            });
            EventEmitter.emit(Events.passDataToChilds, {
                loader: false,
                data: response?.data?.data
            });
        }
    };

    render(): React.ReactNode {
        return null;
    }
}

export default WebsitesData;
